export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        // Check if some hash is in URL and if hash is id of some html element check if it is overlapping with header
        // and if it is overlapping hide header
        jQuery(window).on('load', function () {
            const $header = jQuery(nodeSelectors.container);
            const hash = window.location.hash;
            const $content = jQuery(hash);

            if( $content.length ) {
                const headerBottom = $header[0].getBoundingClientRect().bottom + 50;
                const contentTop = $content[0].getBoundingClientRect().top;
                const isOverlapping = headerBottom > contentTop;

                if ( window.scrollY > 100 && (hash || jQuery(hash).length) && isOverlapping ) {
                    setTimeout(function () {
                        hide();
                    }, 50);
                }
            }
        });

        let scrollDirectionDown = true

        window.addEventListener('scroll', function() {
            /**
             * If logged in user/admin scrolls down and admin bar is not visible anymore
             * this code will add class to body so we can move up header and mobile nav back to top in CSS
             */
            if ( jQuery('body').hasClass('admin-bar') && window.scrollY > 46 ) {
                jQuery('body').addClass('admin-bar-is-active-but-not-in-view')
            } else {
                jQuery('body').removeClass('admin-bar-is-active-but-not-in-view')
            }

            /**
             * Hide/Show header on scroll
             * If user scrolls down header will be hidden or if user scrolls up header will be visible
             */
            scrollDirectionDown = this.oldScroll <= this.scrollY
            this.oldScroll = this.scrollY
            show()

            // if ( scrollDirectionDown ) {
                // Scrolling down
                // if( window.scrollY > 100 && !jQuery(nodeSelectors.container).hasClass('site-header--mobile-nav-is-active') ) {
                //     hide()
                // }
            // } else {
            //     show()
            // }

            /**
             * Set class to header if user scrolls down so it can be styled as a smaller header if there is a need for that
             */
            if( window.scrollY > 100 ) {
                jQuery(nodeSelectors.container).addClass('site-header--scrolled')
            } else {
                jQuery(nodeSelectors.container).removeClass('site-header--scrolled')
            }
        })
    }

    function getHeight() {
        return document.querySelector(nodeSelectors.container).offsetHeight
    }

    function show() {
        document.querySelector(nodeSelectors.container).style.top = '0px'
        document.querySelector(nodeSelectors.container).classList.remove('site-header--hidden')
    }

    function hide() {
        document.querySelector(nodeSelectors.container).style.top = - (document.querySelector(nodeSelectors.container).offsetHeight * 1.8) + 'px'
        document.querySelector(nodeSelectors.container).classList.add('site-header--hidden')
    }

    return Object.freeze({
        init,
        nodeSelectors,
        show,
        hide,
        getHeight
    })
}